import { observer } from './components/IntersectionObservers';

const body = document.querySelector('body');
////////////////////////////////////////////////////////////

// DOMとアセットの読み込みが完了したらbodyにloadedクラス名を追加

////////////////////////////////////////////////////////////

window.addEventListener('load', () => {
  body.classList.add('loaded');
});

////////////////////////////////////////////////////////////

// 画面スクロールに応じてbodyにクラス名を追加

////////////////////////////////////////////////////////////

// 前のスクロール位置を保持する変数
let lastScrollTop = 0;

window.addEventListener(
  'scroll',
  () => {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // スクロール位置が0より大きいかどうかをチェックして、`scrolled`クラスを付与または削除
    if (currentScrollTop > 0) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }

    // スクロール方向に基づいて`scroll-up`または`scroll-down`クラスを切り替え
    if (currentScrollTop > lastScrollTop) {
      // 下にスクロールした場合
      document.body.classList.remove('scroll-up');
      document.body.classList.add('scroll-down');
    } else if (currentScrollTop < lastScrollTop) {
      // 上にスクロールした場合
      document.body.classList.remove('scroll-down');
      document.body.classList.add('scroll-up');
    }

    // 現在のスクロール位置を更新
    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // ネガティブな値を避ける
  },
  false,
);

////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////

// フレームインしたらフェードインさせるターゲット
const targetFadeIn = document.querySelectorAll('.fade-in');
// フレームインしたらふわっと浮き上がりながら表示させるターゲット
const targetFadeRise = document.querySelectorAll('.fade-rise, .fade-rise-all > *');
// フレームインしたら何かしらアクションを起こす
const inFrame = document.querySelectorAll('.in-frame');

targetFadeIn.forEach((e) => observer.observe(e));
targetFadeRise.forEach((e) => observer.observe(e));
inFrame.forEach((e) => observer.observe(e));
